// reach_ui/src/reducers/customForm/index.js
import ActionType from 'actions/ActionType'
import { nanoid } from 'nanoid'
import { combineReducers } from 'redux'
import { omit } from 'lodash'
import { fieldTypeMap } from 'components/AddOrEditFormPage/Form/Main/ResponseView/ChartsContainer'
const update = require('immutability-helper')

const initialState = () => ({
  name: '',
  title: {
    color: '#000000',
    text: '',
  },
  description: {
    color: '#000000',
    text: '',
  },
  display_type: 'popover',
  submit_button: {
    text: 'Submit',
    text_color: '#000000',
    background_color: '#237c0b',
  },
  form: {
    sections: [],
  },
  sectionsByID: {},
  sectionBeingEditedID: null,
  background_color: '#ffffff',
  font: 'Arial',
  text_color: '#000000',
  editSection: null,
  pageSelected: 0,
  sectionSelected: null,
  sectionTypeChosen: 'blank',
  anyChanged: false,
  contactFieldsInUse: {},
  analyticsAnswerPages: {},
  initialItemState: null,
  // id: 'new',
})

const addOrEdit = (state = initialState(), action) => {
  switch (action.type) {
    case ActionType.SignupForm.HANDLE_GROUP_CHANGE:
      return {
        ...state,
        anyChanged: true,
      }
    case ActionType.CustomForm.HANDLE_SECTION_VALUE_CHANGE:
      if (action.payload) {
        const fieldString =
          action.payload.type === 'field' ||
          action.payload.type === 'contactfield'
            ? action.payload.type
            : null

        return {
          ...state,
          sectionsByID: {
            ...state.sectionsByID,
            [action.payload.id]: {
              ...state.sectionsByID[action.payload.id],
              [fieldString || action.payload.property]: fieldString
                ? {
                    ...state.sectionsByID[action.payload.id][fieldString],
                    [action.payload.property]:
                      typeof action.payload.value === 'object'
                        ? Array.isArray(action.payload.value)
                          ? [
                              ...state.sectionsByID[action.payload.id][
                                fieldString
                              ][action.payload.property],
                              ...action.payload.value,
                            ]
                          : {
                              ...state.sectionsByID[action.payload.id][
                                fieldString
                              ][action.payload.property],
                              ...action.payload.value,
                            }
                        : action.payload.value,
                  }
                : typeof action.payload.value === 'object'
                ? {
                    ...state.sectionsByID[action.payload.id][
                      action.payload.property
                    ],
                    ...action.payload.value,
                  }
                : action.payload.value,
            },
          },
          contactFieldsInUse:
            fieldString === 'contactfield'
              ? {
                  ...state.contactFieldsInUse,
                  [action.payload?.value]: true,
                }
              : state.contactFieldsInUse,
        }
      }
      return state
    case ActionType.CustomForm.HANDLE_MULTI_OPTION_CHANGE:
      if (action.payload) {
        const newFieldOptions = field_options => {
          const objs = {
            add: () => {
              return field_options.length
                ? [...field_options, action.payload.value]
                : [action.payload.value]
            },
            edit: () => {
              return field_options.map((field_option, idx) => {
                if (idx === action.payload.index) {
                  return action.payload.value
                }
                return field_option
              })
            },
            remove: () => {
              return update(field_options, {
                $splice: [[action.payload.index, 1]],
              })
            },
          }

          return objs[action.payload.modifyType]()
        }

        return {
          ...state,
          sectionsByID: {
            ...state.sectionsByID,
            [action.payload.id]: {
              ...state.sectionsByID[action.payload.id],
              field: {
                ...state.sectionsByID[action.payload.id].field,
                field_options: newFieldOptions(
                  state.sectionsByID[action.payload.id].field.field_options ||
                    [],
                ),
                boolean_labels: action.payload.bool
                  ? {
                      true_label:
                        action.payload.index === 0
                          ? action.payload.value
                          : state.sectionsByID[action.payload.id].field
                              .boolean_labels.true_label,
                      false_label:
                        action.payload.index === 1
                          ? action.payload.value
                          : state.sectionsByID[action.payload.id].field
                              .boolean_labels.false_label,
                    }
                  : undefined,
              },
            },
          },
        }
      }

      return state
    case ActionType.CustomForm.HANDLE_SECTION_FIELD_CHECKBOX_CHANGE:
      if (action.payload) {
        const field = action.payload.value
          ? {
              ...state.sectionsByID[action.payload.id].field,
              [action.payload.property]: action.payload.defaultValue,
            }
          : omit(
              state.sectionsByID[action.payload.id].field,
              action.payload.property,
            )

        return {
          ...state,
          sectionsByID: {
            ...state.sectionsByID,
            [action.payload.id]: {
              ...state.sectionsByID[action.payload.id],
              field,
            },
          },
        }
      }
      return state
    case ActionType.CustomForm.HANDLE_FORM_VALUE_CHANGE:
      if (typeof action.payload === 'object') {
        return {
          ...state,
          anyChanged: true,
          [action.property]: {
            ...state[action.property],
            ...action.payload,
          },
        }
      } else {
        return {
          ...state,
          anyChanged: true,
          [action.property]: action.payload,
        }
      }
    case ActionType.CustomForm.ADD_SECTION:
      const sections = [...state.form.sections]
      const index = action.payload?.index || state.form.sections.length
      const newItem = {
        label: action.payload?.newSection?.label || '',
        id: nanoid(),
        type:
          action.payload?.newSection?.type === 'sectionPill'
            ? 'field'
            : 'blank',
        description: '',
      }

      sections.splice(index, 0, newItem.id)

      return {
        ...state,
        anyChanged: true,
        form: {
          sections,
          // sections: [
          // 	...state.form.sections,
          // 	action.payload || { type: null, description: '', label: '' },
          // ],
        },
        sectionsByID: {
          ...state.sectionsByID,
          [newItem.id]: newItem,
        },
        editSection: action?.payload?.editSection || null,
        sectionSelected: action?.payload?.sectionSelected || null,
        sectionBeingEditedID: newItem.id,
      }
    case ActionType.CustomForm.CHANGE_SECTION:
      if (Object.keys(action?.payload || {})?.length) {
        return {
          ...state,
          // anyChanged: true,
          sectionsByID: {
            ...state.sectionsByID,
            [action.id]: {
              ...state.sectionsByID[action.id],
              ...action.payload,
            },
          },
          sectionBeingEditedID: action.id,
          sectionSelected: action.payload.visualIndex,
          sectionTypeChosen: 'blank',
          contactFieldsInUse:
            action?.payload?.type === 'contactfield'
              ? {
                  ...state.contactFieldsInUse,
                  [action.payload?.contactfield?.field_name]: true,
                }
              : state.contactFieldsInUse,
        }
      }

      return {
        ...state,
        anyChanged: true,
        form: {
          sections: update(state.form.sections, {
            $splice: [[action.payload.index, 1]],
          }),
        },
        sectionsByID: omit(state.sectionsByID, action.id),
        sectionTypeChosen: 'blank',
      }
    case ActionType.CustomForm.MOVE_SECTION:
      const { dragIndex, hoverIndex, pageBreakIndices } = action
      const dragSection =
        state.pageSelected === 0
          ? state.form.sections[dragIndex]
          : state.form.sections[
              dragIndex + pageBreakIndices[state.pageSelected - 1] + 1
            ]
      const adjustedDragIndex =
        state.pageSelected === 0
          ? dragIndex
          : dragIndex + pageBreakIndices[state.pageSelected - 1] + 1
      const adjustedHoverIndex =
        state.pageSelected === 0
          ? hoverIndex
          : hoverIndex + pageBreakIndices[state.pageSelected - 1] + 1

      return {
        ...state,
        anyChanged: true,
        form: {
          ...state.form,
          sections: update(state.form.sections, {
            $splice: [
              [adjustedDragIndex, 1],
              [adjustedHoverIndex, 0, dragSection],
            ],
          }),
        },
        sectionSelected: hoverIndex,
      }
    case ActionType.CustomForm.MOVE_TO_PAGE:
      const { /* pagebreak, */ page, newIndex } = action.payload
      const currentIndex = action.payload.index
      const current = state.form.sections[currentIndex]
      // const newSectionPlace = state.form.sections[currentIndex]

      return {
        ...state,
        anyChanged: true,
        form: {
          ...state.form,
          sections: update(state.form.sections, {
            $splice: [
              [currentIndex, 1],
              [newIndex, 0, current],
            ],
          }),
          // sections: arrayMove(state.form.sections, currentIndex, newIndex),
        },
        sectionSelected: newIndex,
        pageSelected: page,
      }
    case ActionType.CustomForm.EDIT_SECTION:
      if (action?.payload) {
        return {
          ...state,
          editSection: action.payload.pageIndex,
          sectionBeingEditedID: action.payload.section.id,
          sectionLabel:
            state.form.sections?.[action?.payload?.index]?.label || '',
          sectionDescription:
            state.form.sections?.[action?.payload?.index]?.description || '',
          required:
            state.form.sections?.[action?.payload?.index]?.field?.required ||
            false,
          anyChanged: true,
          initialItemState: action.payload?.section,
        }
      }
      return {
        ...state,
        editSection: null,
        sectionBeingEditedID: null,
        initialItemState: null,
      }
    case ActionType.CustomForm.CANCEL_EDIT:
      if (state.initialItemState && state.sectionBeingEditedID) {
        return {
          ...state,
          sectionsByID: {
            ...state.sectionsByID,
            [state.sectionBeingEditedID]: state.initialItemState,
          },
          initialItemState: null,
          sectionBeingEditedID: null,
          editSection: null,
        }
      }
      return state
    case ActionType.CustomForm.DELETE_SECTION:
      const id = state.form.sections[action.payload.index]
      const section = state.sectionsByID[id]

      return {
        ...state,
        anyChanged: true,
        form: {
          sections: update(state.form.sections, {
            $splice: [[action.payload.index, 1]],
          }),
        },
        sectionsByID: omit(state.sectionsByID, id),
        contactFieldsInUse:
          section?.type === 'contactfield'
            ? omit(state.contactFieldsInUse, section?.contactfield?.field_name)
            : state.contactFieldsInUse,
        sectionBeingEditedID:
          id === state.sectionBeingEditedID ? null : state.sectionBeingEditedID,
        sectionTypeChosen: 'blank',
      }
    case ActionType.CustomForm.RECEIVE_FORM:
      if (action.payload) {
        const sectionsWithIDs =
          action.payload?.form?.sections?.map?.(section => {
            if (section?.field?.field_options === null) {
              return {
                ...section,
                id: section?.field?.field_name || nanoid(),
                field: {
                  ...section.field,
                  field_options: [],
                },
              }
            }

            if (section?.contactfield?.field_options === null) {
              return {
                ...section,
                id: section?.contactfield?.field_name || nanoid(),
                contactfield: {
                  ...section.contactfield,
                  field_options: [],
                },
              }
            }

            return {
              ...section,
              id:
                section?.field?.field_name ||
                section?.contactfield?.field_name ||
                nanoid(),
            }
          }) || []

        const sections = sectionsWithIDs.map(section => section.id)

        return {
          ...state,
          ...action.payload,
          anyChanged: false,
          form: {
            ...(action.payload?.form || {}),
            sections,
          },
          sectionsByID: sectionsWithIDs.reduce((acc, el) => {
            acc[el.id] = el
            return acc
          }, {}),
          contactFieldsInUse: sectionsWithIDs.reduce((acc, el) => {
            if (el?.type === 'contactfield') {
              acc[el?.contactfield?.field_name] = true
            }
            return acc
          }, {}),
          analyticsAnswerPages: sectionsWithIDs.reduce((acc, el) => {
            if (el?.field?.type) {
              acc[
                `${action?.payload?.id}/stats/${
                  fieldTypeMap?.[el?.field?.type]
                }/${el.id}`
              ] = { page: 0, pages: [], cursor: null }
            }
            return acc
          }, {}),
        }
      }
      return initialState()
    case ActionType.CustomForm.GO_TO_PAGE:
      if (typeof action.payload === 'number') {
        return {
          ...state,
          pageSelected: action.payload,
        }
      }

      if (action.payload === 'next') {
        return {
          ...state,
          pageSelected: state.pageSelected + 1,
        }
      }

      if (action.payload === 'prev') {
        return {
          ...state,
          pageSelected: state.pageSelected - 1,
        }
      }

      return state
    case ActionType.CustomForm.SELECT_SECTION:
      if (typeof action.payload === 'number') {
        return {
          ...state,
          sectionSelected: action.payload,
          sectionBeingEditedID:
            action?.item?.id === state.sectionBeingEditedID
              ? state.sectionBeingEditedID
              : null,
        }
      }
      return {
        ...state,
        sectionSelected: null,
        // sectionBeingEditedID: null,
      }
    case ActionType.Data.READ_SUCCESS:
      if (action?.entityType === 'customFormStat' && action?.payload) {
        return {
          ...state,
          analyticsAnswerPages: {
            ...state.analyticsAnswerPages,
            [action?.entityID]: {
              ...state.analyticsAnswerPages[action?.entityID],
              cursor: action.payload?.cursor || null,
              pages: [
                ...state.analyticsAnswerPages[action?.entityID]?.pages,
                action.payload.responses,
              ],
            },
          },
        }
      }
      return state
    // case ActionType.CustomForm.READ_NEXT_ANALYTICS_PAGE:
    // 	return {
    // 		...state,
    // 		analyticsAnswerPages: {
    // 			...state.analyticsAnswerPages,
    // 			[action?.payload?.statsId]: {
    // 				...state.analyticsAnswerPages?.[action?.payload?.statsId],
    // 				page:
    // 					state.analyticsAnswerPages?.[action?.payload?.statsId]?.page + 1,
    // 			},
    // 		},
    // 	}
    case ActionType.CustomForm.PREV_ANALYTICS_PAGE:
      return {
        ...state,
        analyticsAnswerPages: {
          ...state.analyticsAnswerPages,
          [action?.payload?.statsId]: {
            ...state.analyticsAnswerPages?.[action?.payload?.statsId],
            page:
              state.analyticsAnswerPages?.[action?.payload?.statsId]?.page - 1,
          },
        },
      }
    case ActionType.CustomForm.NEXT_ANALYTICS_PAGE:
      return {
        ...state,
        analyticsAnswerPages: {
          ...state.analyticsAnswerPages,
          [action?.payload?.statsId]: {
            ...state.analyticsAnswerPages?.[action?.payload?.statsId],
            page:
              state.analyticsAnswerPages?.[action?.payload?.statsId]?.page + 1,
          },
        },
      }
    default:
      return state
  }
}

export default combineReducers({ addOrEdit })
